export default __webpack_public_path__ + "static/media/153.0cad25c9.gif";